var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconListNumbers = function SvgIconListNumbers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.776 4.024a1 1 0 0 1 .474.851v5.25a1 1 0 1 1-2 0V6.493l-.053.026a1 1 0 1 1-.894-1.788l1.5-.75a1 1 0 0 1 .973.043M9.125 6a1 1 0 0 1 1-1H20.25a1 1 0 1 1 0 2H10.125a1 1 0 0 1-1-1M9.125 12a1 1 0 0 1 1-1H20.25a1 1 0 1 1 0 2H10.125a1 1 0 0 1-1-1M10.125 17a1 1 0 0 0 0 2H20.25a1 1 0 1 0 0-2zM4.964 14.504a.312.312 0 0 1 .37.461L2.95 18.151a1 1 0 0 0 .8 1.599h2.625a1 1 0 1 0 0-2h-.627l1.203-1.607.022-.03a2.312 2.312 0 1 0-4.047-2.181 1 1 0 1 0 1.855.749.31.31 0 0 1 .183-.177"
  }))));
};
export default SvgIconListNumbers;